import { memo } from 'react';

import ImageLoader from '../../molecules/Image';

const SocialMediaLinks = memo(() => (
  <div className='m-b-10 center-y'>
    <a className='mx-2' href='https://twitter.com/in_awign/' rel='noopener noreferrer' target='_blank'>
      <ImageLoader alt='twitter logo' height={18} src='/images/homepage/twitter.svg' width={22} />
    </a>
    <a className='mx-2' href='https://www.facebook.com/awign.internships/' rel='noopener noreferrer' target='_blank'>
      <ImageLoader alt='facebook logo' height={24} src='/images/homepage/facebook.svg' width={24} />
    </a>
    <a className='mx-2' href='https://www.instagram.com/awign_india/' rel='noopener noreferrer' target='_blank'>
      <ImageLoader alt='instagram logo' height={24} src='/images/homepage/instagram.svg' width={24} />
    </a>
    <a className='mx-2' href='https://in.linkedin.com/company/awign-enterprises' rel='noopener noreferrer' target='_blank'>
      <ImageLoader alt='linkedin logo' height={20} src='/images/homepage/linkedin.svg' width={20} />
    </a>
  </div>
));

SocialMediaLinks.displayName = 'SocialMediaLinks';

export default SocialMediaLinks;
